import { connect } from 'react-redux';

import { openPdfModal } from '../../pdf-modal/actions';
import Footer from '../component';

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { pdfModalOpen: openPdfModal })(Footer);
